import { Component, OnInit, Input , ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-gmsnavmenulist',
    templateUrl: './gmsnavmenulist.component.html',
    styleUrls: ['./gmsnavmenulist.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmsnavmenulistComponent implements OnInit {
  @Input() navMenus: any
  constructor() { }

  ngOnInit(): void {
  }
  public expandSelectedMenu(reqnavItem) {
    reqnavItem.expand = !reqnavItem.expand;
  }

}
